import React from "react";
import { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useDisclosure,
  Flex,
  HStack,
  Box,
  Icon,
  SimpleGrid,
  Text,
  Textarea,
  Radio,
  RadioGroup,
  Stack,
  VisuallyHidden,
  Select,
  useColorModeValue,
  useColorMode,
  color,
  Skeleton,
  Divider,
} from "@chakra-ui/react";

import { toast } from "react-toastify";

import ReactSelect from "react-select";
import Creatable from 'react-select/creatable';

import locations from "variables/locations";
import { format, toZonedTime } from 'date-fns-tz';
import { FaRotate } from "react-icons/fa6";

import { CheckIcon } from "@chakra-ui/icons";

import {
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Checkbox,
  CheckboxGroup,
} from "@chakra-ui/react";

import {
  onSiteVehiclesOptionsJRG1,
  onSiteVehiclesOptionsJRG2,
  onSiteVehiclesOptionsSP,
  onSiteVehiclesOptionsWSP,
  sluzby,
  grupy,
} from "variables/general";

import Card from "components/Card/Card.js";
import CustomCheckbox from "components/Checkbox/CustomCheckbox";
import CustomCheckboxButton from "components/Checkbox/CustomCheckboxButton";
import axios from "axios";
import apiUrl from "../../../variables/api";
import { set } from "react-hook-form";
import darkStyles from "variables/darkStyles";

const refreshDateTime = () => {
  const now = new Date();
  const timeZone = 'Europe/Warsaw';
  const polandTime = toZonedTime(now, timeZone);
  return format(polandTime, "yyyy-MM-dd'T'HH:mm");
};

const initialValues = {
  dateTime: refreshDateTime(),
  reporter: "",
  location: "",
  commander: {
    value: localStorage.getItem("id"),
    label: localStorage.getItem("nickname"),
  },
  incidentType: "",
  peoplesOnSite: [],
  onSiteServices: [],
  onSiteVehicles: [],
  incidentDescription: "",
};

const initialImportValues = {
  dataId: "",
};

export default function Incident() {
  // console.log("style", darkStyles())
  const { colorMode } = useColorMode();

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [vehicles, setVehicles] = useState([]);
  const [disabledVehicles, setDisabledVehicles] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/vehicles", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        const vehicles = response.data;
        const formattedData = vehicles.reduce((acc, item) => {
          const existingUnit = acc.find((unit) => unit.unit === item.unit);
          if (existingUnit) {
            existingUnit.vehicles.push(item.operationalNumber);
          } else {
            acc.push({ unit: item.unit, vehicles: [item.operationalNumber] });
          }
          return acc;
        }, []);
        setVehicles(formattedData);

        const disabledVehicles = vehicles.filter(vehicle => vehicle.disabled).map(vehicle => vehicle.operationalNumber)
        setDisabledVehicles(disabledVehicles);

      console.log(formattedData);
      console.log(disabledVehicles);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const validate = (values) => {
    const errors = {};

    if (!values.onSiteVehicles || values.onSiteVehicles.length === 0) {
      errors.onSiteVehicles = "Musisz wybrać co najmniej jedno pole";
    }

    if (!values.commander || values.commander.length === 0) {
      errors.commander = "Musisz wybrać dowódce";
    }

    if (!values.peoplesOnSite || values.peoplesOnSite.length === 0) {
      errors.peoplesOnSite = "Musisz podać osoby na miejscu";
    }

    if (!values.incidentType) {
      errors.incidentType = "Musisz wybrać rodzaj zdarzenia";
    }

    if (!values.dateTime) {
      errors.dateTime = "Musisz wybrać godzinę";
    }

    if (!values.reporter) {
      errors.reporter = "Musisz podać zgłaszającego";
    }

    if (!values.location) {
      errors.location = "Musisz podać lokalizację";
    }

    if(values.incidentDescription.length < 10) {
      errors.incidentDescription = "Opis zdarzenia musi zawierać co najmniej 10 znaków"
    }

    console.log(errors);
    return errors;
  };

  const validateImport = (values) => {
    const errors = {};

    if (!values.dataId) {
      errors.dataId = "Musisz podać ID Raportu SK";
    }

    console.log(errors);
    return errors;
  };

  const [formData, setFormData] = useState({
    dateTime: "",
    reporter: "",
    location: "",
    commander: "",
    incidentType: "",
    peoplesOnSite: [],
    onSiteServices: [],
    onSiteVehicles: [],
    incidentDescription: "",
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();
  const formikRef = React.useRef();

  const [isOpenImport, setOpenImport] = useState(false);

  const onOpenImport = () => setOpenImport(true);
  const onCloseImport = () => setOpenImport(false);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);

    setFormData(values);
    onOpen();
  };

  const handleFinalSubmit = (values) => {
    console.log("Wysyłanie formularza", formData);
    if(!formikRef.current.isSubmitting) return;
    onClose();
    axios
      .post(apiUrl + "/data/incident", formData, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          formikRef.current.setFieldValue("dateTime", refreshDateTime());
          formikRef.current.setFieldValue("peoplesOnSite", []);
          formikRef.current.setFieldValue("reporter", "");
          formikRef.current.setFieldValue("location", "");
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano kartę wyjazdową");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error(
            "Napotkano błąd podczas wysyłania karty wyjazdowej"
          );
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
    //setSubmitting(false)
  };

  const handleFinalCloseSubmit = (values) => {
    formikRef.current.setSubmitting(false);
    onClose();
    //setSubmitting(false)
  };

  const handleImportSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Importowanie danych", values);
    axios
      .get(apiUrl + `/data/sk/${values.dataId}`, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        formikRef.current.setFieldValue("dateTime", new Date(response.data.date)
          .toISOString()
          .slice(0, 16))
        formikRef.current.setFieldValue("reporter", response.data.reporting)
        formikRef.current.setFieldValue("location", { label: response.data.location, value: response.data.location})
        setSubmitting(false);
        onCloseImport();
        return toast.success("Pomyślnie zaimportowano dane z raportu SK");
      })
      .catch((error) => {
        console.error(error);
        setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex direction="column">
          <Formik
            initialValues={initialValues}
            validate={validate}
            onSubmit={handleSubmit}
            innerRef={formikRef}
          >
            {({ isSubmitting, formik }) => (
              <Form>
                <SimpleGrid
                  columns={{ sm: 1, md: 2, xl: 4 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="dateTime">
                    {({ field, form }) => (
                      <FormControl
                        id="dateTime"
                        isRequired
                        isInvalid={
                          form.errors.dateTime && form.touched.dateTime
                        }
                      >
                        <FormLabel display="flex" alignItems="center" gap="8px">
                                                  Data i godzina
                                                  <Box
                                                    onClick={(e) => {
                                                      form.setFieldValue("dateTime", refreshDateTime());
                                                      console.log("Odświeżono datę i godzinę", form.values.dateTime);
                                                      toast.success("Odświeżono datę i godzinę");
                                                    }}
                                                    cursor="pointer"
                                                  >
                                                    <FaRotate color="lightblue" />
                                                  </Box>
                                                </FormLabel>
                        <Input
                          type="datetime-local"
                          {...field}
                          placeholder="Data i godzina"
                        />
                        <FormErrorMessage>
                          {form.errors.dateTime}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="reporter">
                    {({ field, form }) => (
                      <FormControl
                        id="reporter"
                        isRequired
                        isInvalid={
                          form.errors.reporter && form.touched.reporter
                        }
                      >
                        <FormLabel>Zgłaszający</FormLabel>
                        <Input {...field} placeholder="Zgłaszający" />
                        <FormErrorMessage>
                          {form.errors.reporter}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="location">
                    {({ field, form }) => (
                      <FormControl
                        id="location"
                        isRequired
                        isInvalid={
                          form.errors.location && form.touched.location
                        }
                      >
                        <FormLabel>Lokalizacja</FormLabel>
                        <Creatable
                          {...field}
                          options={locations}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values[field.name]}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                          formatCreateLabel={(inputValue) => `Niestandardowa: ${inputValue}`}
                        />
                        <FormErrorMessage>
                          {form.errors.location}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="commander">
                    {({ field, form }) => (
                      <FormControl
                        id="commander"
                        isRequired
                        isInvalid={
                          form.errors.commander && form.touched.commander
                        }
                      >
                        <FormLabel>Dowódca</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.commander}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                        <FormErrorMessage>
                          {form.errors.commander}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <SimpleGrid
                  columns={{ sm: 1, md: 2, xl: 3 }}
                  spacing="24px"
                  mb="20px"
                >
                  <Field name="peoplesOnSite">
                    {({ field, form }) => (
                      <FormControl
                        id="peoplesOnSite"
                        isRequired
                        isInvalid={
                          form.errors.peoplesOnSite &&
                          form.touched.peoplesOnSite
                        }
                      >
                        <FormLabel>Osoby na zdarzeniu</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples.filter(
                            (element) =>
                              element.value !== form.values.commander.value
                          )}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                            isMulti
                          value={form.values.peoplesOnSite}
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                        <FormErrorMessage>
                          {form.errors.peoplesOnSite}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="incidentType">
                    {({ field, form }) => (
                      <FormControl
                        id="incidentType"
                        isRequired
                        isInvalid={
                          form.errors.incidentType && form.touched.incidentType
                        }
                      >
                        <FormLabel fontWeight={"bold"}>Rodzaj zdarzenia</FormLabel>
                        <RadioGroup name="incidentType" colorScheme="red">
                          <Stack direction="row">
                            <CustomCheckbox
                              key="P"
                              label="Pożar"
                              isChecked={form.values.incidentType == "P"}
                              onChange={() => {
                                form.setFieldValue(field.name, "P");
                              }}
                            />
                            <CustomCheckbox
                              key="MZ"
                              label="Miejscowe zagrożenie"
                              isChecked={form.values.incidentType == "MZ"}
                              onChange={() => {
                                form.setFieldValue(field.name, "MZ");
                              }}
                            />
                            <CustomCheckbox
                              key="AF"
                              label="Alarm fałszywy"
                              isChecked={form.values.incidentType == "AF"}
                              onChange={() => {
                                form.setFieldValue(field.name, "AF");
                              }}
                            />
                                                        <CustomCheckbox
                              key="O"
                              label="Inne"
                              isChecked={form.values.incidentType == "O"}
                              onChange={() => {
                                form.setFieldValue(field.name, "O");
                              }}
                            />
                          </Stack>
                        </RadioGroup>
                        <FormErrorMessage>
                          {form.errors.incidentType}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>

                  <Field name="onSiteServices">
                    {({ field, form }) => (
                      <FormControl
                        isInvalid={
                          form.errors.onSiteServices &&
                          form.touched.onSiteServices
                        }
                      >
                        <FormLabel fontWeight={"bold"}>Służby na miejscu</FormLabel>
                        <Stack direction="row">
                          {sluzby.map((option) => (
                            <CustomCheckbox
                              key={option.value}
                              label={option.label}
                              colorScheme={option.color}
                              isChecked={form.values.onSiteServices.includes(
                                option.value
                              )}
                              onChange={() => {
                                const nextValue = field.value.includes(
                                  option.value
                                )
                                  ? field.value.filter(
                                      (value) => value !== option.value
                                    )
                                  : [...field.value, option.value];
                                form.setFieldValue(field.name, nextValue);
                              }}
                            />
                          ))}
                        </Stack>
                        <FormErrorMessage>
                          {form.errors.onSiteServices}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                </SimpleGrid>
                <Field name="onSiteVehicles">
                  {({ field, form }) => (
                    <FormControl
                      id="onSiteVehicles"
                      isInvalid={
                        form.errors.onSiteVehicles &&
                        form.touched.onSiteVehicles
                      }
                    >
                      <FormLabel textAlign={"center"}>
                        <Text fontWeight={"bold"} fontSize={"md"}>
                          Zastępy na miejscu
                        </Text>
                      </FormLabel>
                      <Flex
                        direction={{ base: "column", xl: "row" }}
                        wrap="wrap"
                        justifyContent={{ base: "center", xl: "space-between" }}
                        alignItems="stretch"

                      >
                        {vehicles.length === 0 ? (
                          <Skeleton height="200px" width="100%" />
                        ) : (
                          vehicles.map((unit, index) => (
                            <React.Fragment key={unit.unit}>
                              <Flex direction={"column"} flex="1" mx={2} mb={4}>
                                <FormLabel
                                  fontWeight="bold"
                                  textAlign={"center"}
                                >
                                  {unit.unit}
                                </FormLabel>
                                <SimpleGrid
                                  columns={{ sm: 2, md: 3, xl: 3 }}
                                  spacing="24px"
                                  mb="20px"
                                >
                                  {unit.vehicles.map((vehicle) => (
                                    <CustomCheckboxButton
                                      key={vehicle}
                                      label={vehicle}
                                      disabled={disabledVehicles.includes(vehicle)}
                                      isChecked={form.values.onSiteVehicles.includes(
                                        vehicle
                                      )}
                                      onChange={() => {
                                        const nextValue = field.value.includes(
                                          vehicle
                                        )
                                          ? field.value.filter(
                                              (value) => value !== vehicle
                                            )
                                          : [...field.value, vehicle];
                                        form.setFieldValue(
                                          field.name,
                                          nextValue
                                        );
                                      }}
                                    />
                                  ))}
                                </SimpleGrid>
                              </Flex>
                              {index < vehicles.length - 1 && (
                                <Divider
                                  orientation="vertical"
                                  height="auto"
                                  mx={2}
                                />
                              )}
                            </React.Fragment>
                          ))
                        )}
                      </Flex>
                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Field name="incidentDescription">
                  {({ field, form }) => (
                    <FormControl id="incidentDescription"
                    isInvalid={
                      form.errors[field.name] &&
                      form.touched[field.name]
                    }
                    isRequired
                    >
                      <FormLabel>Opis zdarzenia</FormLabel>
                      <Textarea {...field} placeholder="Opis zdarzenia" maxH={"500px"} maxLength={"4096"}/>
                      <FormErrorMessage>
                        {form.errors[field.name]}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>

                <Button
                  mt={4}
                  mr={2}
                  colorScheme="red"
                  isLoading={isSubmitting}
                  type="submit"
                >
                  Wyślij
                </Button>

                <Button mt={4} mr={2} colorScheme="gray" onClick={onOpenImport}>
                  Importowanie danych
                </Button>

                <AlertDialog
                  isOpen={isOpen}
                  leastDestructiveRef={cancelRef}
                  onClose={onClose}
                >
                  <AlertDialogOverlay>
                    <AlertDialogContent>
                      <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        Potwierdź zgłoszenie
                      </AlertDialogHeader>

                      <AlertDialogBody mt={-3}>
                        Czy na pewno chcesz wysłać te dane? <br />
                        Data i godzina: {formData.dateTime.replace(
                          "T",
                          " "
                        )}{" "}
                        <br />
                        Zgłaszający: {formData.reporter} <br />
                        Lokalizacja: {formData.location.label} <br />
                        Dowódca: {formData.commander.label} <br />
                        Rodzaj zdarzenia:{" "}
                        {formData.incidentType
                          .replace("P", "Pożar")
                          .replace("MZ", "Miejscowe zagrożenie")
                          .replace("AF", "Alarm fałszywy")
                          .replace("O", "Inne")}{" "}
                        <br />
                        Służby na miejscu: {formData.onSiteServices.join(
                          ", "
                        )}{" "}
                        <br />
                        Osoby na zdarzeniu:{" "}
                        {formData.peoplesOnSite
                          .map((member) => member.label)
                          .join(", ")}{" "}
                        <br />
                        Wozy na miejscu: {formData.onSiteVehicles.join(
                          ", "
                        )}{" "}
                        <br />
                        Opis zdarzenia:{" "}
                        {formData.incidentDescription !== ""
                          ? formData.incidentDescription
                          : "-"}
                      </AlertDialogBody>

                      <AlertDialogFooter>
                        <Button
                          ref={cancelRef}
                          onClick={handleFinalCloseSubmit}
                        >
                          Anuluj
                        </Button>
                        <Button
                          colorScheme="red"
                          onClick={handleFinalSubmit}
                          ml={3}
                        >
                          Wyślij
                        </Button>
                      </AlertDialogFooter>
                    </AlertDialogContent>
                  </AlertDialogOverlay>
                </AlertDialog>
              </Form>
            )}
          </Formik>

          <AlertDialog
            isOpen={isOpenImport}
            //leastDestructiveRef={cancelRef}
            onClose={onCloseImport}
          >
            <AlertDialogOverlay>
              <AlertDialogContent>
                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                  Importowanie danych
                </AlertDialogHeader>

                <AlertDialogBody mt={-3}>
                  <Formik
                    initialValues={initialImportValues}
                    validate={validateImport}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={handleImportSubmit}
                  >
                    {({ isSubmitting, formik }) => (
                      <Form>
                        <Field name="dataId">
                          {({ field, form }) => (
                            <FormControl
                              id="dataId"
                              isRequired
                              isInvalid={
                                form.errors.dataId && form.touched.dataId
                              }
                            >
                              <FormLabel>ID raportu</FormLabel>
                              <Input
                                type="number"
                                {...field}
                                placeholder="Wprowadź ID raportu"
                              />
                              <FormErrorMessage>
                                {form.errors.dataId}
                              </FormErrorMessage>
                            </FormControl>
                          )}
                        </Field>

                        <Button
                          mt={4}
                          colorScheme="red"
                          isLoading={isSubmitting}
                          type="submit"
                        >
                          Importuj
                        </Button>
                        <Button
                          mt={4}
                          ml={2}
                          colorScheme="gray"
                          onClick={onCloseImport}
                        >
                          Anuluj
                        </Button>
                      </Form>
                    )}
                  </Formik>
                </AlertDialogBody>
              </AlertDialogContent>
            </AlertDialogOverlay>
          </AlertDialog>
        </Flex>
      </Card>
    </Flex>
  );
}
